import { useQuery } from "react-query";
import { QueryKeys } from "../../network/queryKeys";
import { SpecAPI } from "../../api/specs";
import { Selectors as UserSelectors } from "@/store/user/selectors";
import { useSelector } from "react-redux";
import ms from "ms";
import { createSelector } from "reselect";

const selector = createSelector(
  (state) => state,
  (state) => {
    return Object.entries(state?.specs || {})
      .map(([_id, data]) => ({ _id, ...data }))
      .filter((spec) => spec.searchable);
  }
);
export const useSearchableSpecsQuery = () => {
  const locale = useSelector(UserSelectors.getLocale);
  return useQuery(
    [QueryKeys.allSpecs, { locale }],
    () => SpecAPI.getAll({ locale }),
    {
      staleTime: ms("1 hour"),
      cacheTime: Infinity,
      select: selector,
    }
  );
};
